import React from 'react';
import { normalizeCommunityInviteHref } from './communityInviteUrl';

const URL_REGEX = /https?:\/\/[^\s<>"']+/g;

/** Bare host URLs without protocol, e.g. app.canadawaleyar.com/path or localhost:5174/path */
const BARE_URL_REGEX =
  /(?:^|[\s(])((?:localhost(?::\d+)?|(?:[\w-]+\.)+[\w-]{2,})(?:\/[^\s<>"']*)?)/gi;

function hrefForUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) return url;
  const withProtocol =
    url.startsWith('localhost') || url.startsWith('127.') ? `http://${url}` : `https://${url}`;
  const inviteToken = /\/community\/invite\/([A-Za-z0-9_-]+)/.exec(url)?.[1];
  if (inviteToken) {
    return normalizeCommunityInviteHref(url, inviteToken);
  }
  return withProtocol;
}

function pushLink(nodes: React.ReactNode[], url: string, key: string): void {
  nodes.push(
    <a
      key={key}
      href={hrefForUrl(url)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      style={{ color: '#027eb5', textDecoration: 'underline', wordBreak: 'break-all' }}
    >
      {url}
    </a>
  );
}

export function linkifyText(text: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;

  const matches: Array<{ start: number; end: number; url: string }> = [];

  const httpRe = new RegExp(URL_REGEX.source, URL_REGEX.flags);
  let httpMatch: RegExpExecArray | null;
  while ((httpMatch = httpRe.exec(text)) !== null) {
    matches.push({ start: httpMatch.index, end: httpRe.lastIndex, url: httpMatch[0] });
  }

  const bareRe = new RegExp(BARE_URL_REGEX.source, BARE_URL_REGEX.flags);
  let bareMatch: RegExpExecArray | null;
  while ((bareMatch = bareRe.exec(text)) !== null) {
    const leading = bareMatch[0].slice(0, bareMatch[0].indexOf(bareMatch[1]));
    const start = bareMatch.index + leading.length;
    const url = bareMatch[1];
    const end = start + url.length;
    const overlapsHttp = matches.some((m) => start >= m.start && start < m.end);
    if (!overlapsHttp) {
      matches.push({ start, end, url });
    }
  }

  matches.sort((a, b) => a.start - b.start);

  for (const match of matches) {
    if (match.start > lastIndex) {
      nodes.push(text.slice(lastIndex, match.start));
    }
    pushLink(nodes, match.url, `${match.start}-${match.url}`);
    lastIndex = match.end;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes.length ? nodes : [text];
}
